<template>
	<div :class="customName">
		<div>
			<span class="subRate" v-if="tableData.sub">{{
				typeof tableData.sub == 'function' ? tableData.sub(scope.row) : scope.row[tableData.sub]
			}}</span>
			<span class="mainRate" v-if="tableData.main">{{
				typeof tableData.main == 'function' ? tableData.main(scope.row) : scope.row[tableData.main]
			}}</span>
		</div>
		<div>
			<span class="rate">
				{{ tableData.complete(scope.row) }}
			</span>
			<i class="question el-icon-question" v-if="tableData.event" @click="getDetail"></i>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {};
	},
	computed: {
		customName() {
			return this.tableData.customName ? this.tableData.customName : 'task';
		},
	},
	watch: {},
	mounted() {},
	methods: {
		getDetail() {
			this.tableData.event && this.tableData.event(this.scope.row);
		},
	},
};
</script>
<style lang="scss" scoped>
.task {
	padding-right: 20px;
	.question {
		cursor: pointer;
	}
	.subRate {
		font-size: 16px;
		font-weight: bold;
		margin-right: 5px;
	}
	.mainRate {
		font-size: 32px;
		font-weight: bold;
	}
}
</style>
